import React, { useState } from 'react';
import './header.css'; // Import the CSS

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="navbar">
      <div className="logo">
        {/* <img src={logo} alt="Tasker Logo" /> */}
        <span className="brand">HANDYMAN</span>
      </div>

      <nav className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
        <ul>
          <li><a href="/templates/handyman/">Home</a></li>
          <li><a href="/templates/handyman/about-us">About Us </a></li>
          <li><a href="/templates/handyman/services">Services </a></li>
        </ul>
      </nav>

      <a href="tel:+1234567890" className="get-in-touch">Get in Touch</a>

      <div className="menu-toggle" onClick={toggleMenu}>
        ☰
      </div>
    </header>
  );
};

export default Header;
